import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, signal, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { COMMON_ENTITY_CONFIG, EntityServiceConfig, SystemAttribute, SystemAttributeBaseService, UiService } from 'ui-ionic-comp';
import { DraftSeasons, DraftStatuses, DraftTypes, TeamGenders, VisibilityGroups } from '../drafts/draft.entity';

@Injectable({
  providedIn: 'root'
})
export class SystemAttributeService extends SystemAttributeBaseService {

  draftTypes: Signal<SystemAttribute[]> = signal<SystemAttribute[]>([]);
  draftSeasons: Signal<SystemAttribute[]> = signal<SystemAttribute[]>([]);
  draftStatuses: Signal<SystemAttribute[]> = signal<SystemAttribute[]>([]);
  genders: Signal<SystemAttribute[]> = signal<SystemAttribute[]>([]);
  visibilityGroups: Signal<SystemAttribute[]> = signal<SystemAttribute[]>([]);

  constructor(
    @Inject(COMMON_ENTITY_CONFIG) __config: EntityServiceConfig,
    private __httpClient: HttpClient,
    private __uiService: UiService
  ) {
    super(__config, __httpClient, __uiService);
  }

  setDraftTypes() {
    this.draftTypes = toSignal(this.getChildren$(DraftTypes.Parent), { initialValue: [] });
  }

  setDraftSeasons() {
    this.draftSeasons = toSignal(this.getChildren$(DraftSeasons.Parent), { initialValue: [] });
  }

  setDraftStatuses() {
    this.draftStatuses = toSignal(this.getChildren$(DraftStatuses.Parent), { initialValue: [] });
  }

  setGenders() {
    this.genders = toSignal(this.getChildren$(TeamGenders.Parent), { initialValue: [] });
  }

  setVisibilityGroups() {
    this.visibilityGroups = toSignal(this.getChildren$(VisibilityGroups.Parent), { initialValue: [] });
  }
}
